import { Columns, Column } from '@codeparva/ui-components-library';
import React from 'react';
import { HeroTypes } from '../..';
import { Row } from '../../../../../../components/row/Row';
import { WhyChooseUs } from '../../../../../homePage';
import { FormattedHrs } from '../../../../../sitewide/components/locationMap/components/FormattedHrs';
import { WhatWeOffer } from './../../../../../homePage';

const onFacilityHrsToggle = () => {};

export const FacilityVariant2 = ({
  facilityAmenities,
  renderDetails,
  formattedHrs,
  curLocation,
  GenericTextComponent,
  addressDetails,
}: HeroTypes.TFacilityDetailsVariant) => {
  const showAmenity = () => {
    if (facilityAmenities) {
      const {
        variant,
        whyChooseUsConfig,
        whatWeOfferConfig,
      } = facilityAmenities;

      const getComponent = () => {
        if (variant === 'What We Offer' && whatWeOfferConfig) {
          return <WhatWeOffer {...whatWeOfferConfig} />;
        }
        if (variant === 'Why Choose Us' && whyChooseUsConfig) {
          return <WhyChooseUs {...whyChooseUsConfig} />;
        }
        return <></>;
      };

      return (
        <Row>
          <Columns className="is-cp-w-100">
            <Column paddingless>
              {renderDetails({
                label: 'Amenities',
                content: getComponent(),
                noPadding: true,
              })}
            </Column>
          </Columns>
        </Row>
      );
    }
    return <></>;
  };

  return (
    <div className="variant2">
      {facilityAmenities && showAmenity()}
      <Row className="is-cp-w-100">
        <Columns className="is-cp-w-100">
          <Column className="phoneCol" paddingless>
            {renderDetails({
              label: 'Phone Info',
              content: (
                <GenericTextComponent
                  type="phone"
                  text={curLocation.contactNumber}
                  icon="FaPhoneAlt"
                />
              ),
              noPadding: true,
            })}
          </Column>
          <Column className="phoneCol" paddingless>
            {renderDetails({
              label: 'Email Info',
              content: (
                <GenericTextComponent
                  type="email"
                  text={curLocation.emailAddress}
                  icon="FaPhoneAlt"
                />
              ),
              noPadding: true,
            })}
          </Column>
        </Columns>
      </Row>
      <Row className="is-cp-w-100">
        <Columns className="is-cp-w-100">
          <Column paddingless>
            {renderDetails({
              label: 'Facility Office Hours',
              content: (
                <FormattedHrs
                  hideToggle
                  formattedHrs={formattedHrs}
                  show="facilityHrsOnly"
                  onFacilityHrsToggle={onFacilityHrsToggle}
                  titleClassName="subtitle1"
                />
              ),
              noPadding: true,
            })}
          </Column>
          <Column paddingless>
            {renderDetails({
              label: 'Storage Access Hours',
              content: (
                <FormattedHrs
                  hideToggle
                  formattedHrs={formattedHrs}
                  show="gateHrsOnly"
                  onFacilityHrsToggle={onFacilityHrsToggle}
                  titleClassName="subtitle1"
                />
              ),
              noPadding: true,
            })}
          </Column>
        </Columns>
      </Row>
      <Row className="is-cp-w-100">
        <Columns className="is-cp-w-100">
          <Column paddingless>
            {renderDetails({
              label: 'Facility Address',
              content: curLocation.addressText,
              clickableTextConfig: addressDetails,
              noPadding: true,
            })}
          </Column>
          <Column paddingless>
            {renderDetails({
              label: 'Mailing Address',
              content:
                curLocation?.mailingAddressText || curLocation.addressText,
              noPadding: true,
            })}
          </Column>
        </Columns>
      </Row>
    </div>
  );
};
